import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://accreditation.sportix.ae/api';

export const mediaUrl = (path) => path ? `${API_BASE.replace('/api', '')}${path}` : null;

const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('accred_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('accred_token');
      localStorage.removeItem('accred_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default client;
